import { getCdnUrl, loadCSS, loadScript } from '@/utils/helpers'
import { getShadow } from '@/core/init'
import { getSentryUrl } from '@/config'

export const toolbarOptions = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  // ['blockquote', 'code-block'],
  ['image'],
  [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
  // [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  // [{ direction: 'rtl' }], // text direction
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ align: [] }]
]

class CustomImage extends Image {
  static create(value) {
    const node = super.create(value)
    node.setAttribute('src', value) // 确保 src 被设置
    return node
  }
}

// 初始化 Quill 编辑器: 加载资源+初始化实例
export async function initQuill({ getQuill, id }) {
  await loadQuillJs()

  // 注册自定义 image handler
  const Image = Quill.import('formats/image')

  Quill.register(CustomImage, true)
  Quill.register('modules/resize', window.QuillResizeModule)

  const quill = new Quill(id, {
    modules: {
      toolbar: {
        // container: [
        //   [{ header: [1, 2, false] }],
        //   ['bold', 'italic', 'link', 'image'] // 包含 image 按钮
        // ],
        container: toolbarOptions,

        handlers: {
          image: imageHandler({ getQuill }) // 自定义处理函数
        }
      },
      resize: {
        locale: {}
      }
    },
    theme: 'snow'
  })
  // 先这么处理，禁止图片粘贴（会转成base64）
  try {
    quill.uploader.options.mimetypes = []
  } catch (e) {
    console.log('disable图片粘贴失败！')
  }
  return quill
}

// 加载 Quill 资源: 样式+脚本
export function loadQuill() {
  loadCSS(getCdnUrl('/quill/2.0.3/quill.snow.css'))
  loadQuillJs()
  // appendResizeModuleCss()
}

// 加载 Quill 脚本: 核心+扩展模块
export function loadQuillJs() {
  return Promise.all([
    loadScript(getCdnUrl('/quill/2.0.3/quill.min.js')),
    // 自定义的改造版本，实现插件支持shadow dom的场景
    // loadScript(getCdnUrl('/quill/2.0.3/quill-resize-module.custom.min.js'))
    loadScript(getCdnUrl('/quill/2.0.3/quill-resize-module.min.js'))
  ])
}

// export function appendResizeModuleCss() {
//   ;(function (t) {
//     const shadow = getShadow()
//     if (t && 'undefined' != shadow) {
//       const e = document.createElement('style')
//       e.setAttribute('media', 'screen'),
//         (e.innerHTML = t),
//         shadow.appendChild(e)
//     }
//   })(
//     '#editor-resizer {\n  position: absolute;\n  border: 1px dashed #fff;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n#editor-resizer .handler {\n  position: absolute;\n  right: -5px;\n  bottom: -5px;\n  width: 10px;\n  height: 10px;\n  border: 1px solid #333;\n  background-color: rgba(255, 255, 255, 0.8);\n  cursor: nwse-resize;\n  user-select: none;\n}\n#editor-resizer .toolbar {\n  position: absolute;\n  top: -5em;\n  left: 50%;\n  padding: 0.5em;\n  border: 1px solid #fff;\n  border-radius: 3px;\n  background-color: #fff;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\n  transform: translateX(-50%);\n  width: fit-content;\n}\n#editor-resizer .toolbar .group {\n  display: flex;\n  border: 1px solid #aaa;\n  border-radius: 6px;\n  white-space: nowrap;\n  text-align: center;\n  line-height: 2;\n  color: rgba(0, 0, 0, 0.65);\n}\n#editor-resizer .toolbar .group:not(:first-child) {\n  margin-top: 0.5em;\n}\n#editor-resizer .toolbar .group .btn {\n  flex: 1 0 0;\n  text-align: center;\n  padding: 0 0.5rem;\n  display: inline-block;\n  vertical-align: top;\n  user-select: none;\n  color: inherit;\n}\n#editor-resizer .toolbar .group .btn:not(:last-child) {\n  border-right: 1px solid #bbb;\n}\n#editor-resizer .toolbar .group .btn:not(.btn-group):active {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n#editor-resizer .toolbar .group .input-wrapper {\n  width: 25%;\n  border: 1px solid #eee;\n  position: relative;\n  border-right: 1px solid #bbb;\n  min-width: 4em;\n}\n#editor-resizer .toolbar .group .input-wrapper::after {\n  content: " ";\n  position: absolute;\n  height: 1px;\n  background-color: #333;\n  left: 0.5em;\n  right: 1em;\n  bottom: 0.2em;\n}\n#editor-resizer .toolbar .group .input-wrapper input {\n  color: inherit;\n  text-align: center;\n  width: 100%;\n  border: none;\n  outline: none;\n  padding: 0 0.5em;\n  padding-right: 1.5em;\n}\n#editor-resizer .toolbar .group .input-wrapper input:focus ~ .tooltip {\n  display: block;\n}\n#editor-resizer .toolbar .group .input-wrapper .suffix {\n  position: absolute;\n  right: 0.5em;\n}\n#editor-resizer .toolbar .group .input-wrapper .tooltip {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  font-size: small;\n  background-color: #fff;\n  box-shadow: 0 0 3px #a7a7a7;\n  padding: 0 0.6em;\n  border-radius: 5px;\n  zoom: 0.85;\n}\n'
//   )
// }

// 图片上传处理函数
const imageHandler =
  ({ getQuill }) =>
  async () => {
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()

    input.onchange = async () => {
      const quill = getQuill()
      const file = input.files[0]
      if (!file) return

      let placeholder = ''

      try {
        // 显示加载占位符（可选）
        const range = quill.getSelection()
        quill.insertText(range.index, placeholder)

        // 上传到你的服务器
        const imageUrl = await uploadImage(file)

        // 替换占位符为真实图片
        const newIndex = range.index + placeholder.length
        quill.deleteText(range.index, placeholder.length)
        quill.insertEmbed(newIndex, 'image', imageUrl)
        quill.setSelection(newIndex + 1)
      } catch (error) {
        console.error('上传失败:', error)
        alert('图片上传失败')
        // 删除占位符（可选）
        const range = quill.getSelection()
        if (range && range.index > 0) {
          quill.deleteText(range.index - placeholder.length, placeholder.length)
        }
      }
    }
  }

// 上传函数（替换为你自己的 API）
async function uploadImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  const res = await (
    await fetch(`${getSentryUrl()}/upload`, {
      method: 'POST',
      body: formData,
      headers: {
        'tf-sentry-key': import.meta.env.VITE_APP_SENTRY_API_KEY
      }
    })
  ).json()

  if (!res.success) throw new Error('上传失败')
  res.data = res.data || {}
  return res.data.url
}
